import { Entity } from "../common-models/Entity";
import { ContactType } from "../enums/ContactType";
import { InternalCommunicationType } from "../enums/InternalCommunicationType";
import { ResultType } from "../enums/ResultType";

export class InternalCommunicationLog extends Entity {
    contactType: ContactType;
    internalCommunicationType: InternalCommunicationType;
    message: string;
    urlToSend: string
    contact: string
    createdAt: Date;
    processedAt?: Date;
    resultType: ResultType;
    resultDetails: string
    relatedOrderId?: number;
    relatedOrderNumber?: string;
    relatedCustomerName: string;
}